import { render, staticRenderFns } from "./QEventsScoreCard.vue?vue&type=template&id=5982647d&scoped=true&"
import script from "./QEventsScoreCard.vue?vue&type=script&lang=js&"
export * from "./QEventsScoreCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5982647d",
  null
  
)

export default component.exports